import { useRef } from 'react';

import { ServiceFeeCalculateResponse } from '../../../../server/views/serviceFees/serviceFees.types';

export type UseServiceFeeNoticeArgs = {
  enquiryId: string | number | null | undefined;
  serviceFee: ServiceFeeCalculateResponse | null;
  soldForFigure: number | null;
  vrm: string;
};

export const useServiceFeeNotice = ({
  enquiryId,
  serviceFee,
  soldForFigure,
  vrm,
}: UseServiceFeeNoticeArgs): { feeAmountGBP: number } | null => {
  const feeMismatchLogged = useRef(false);
  const feeMissingLogged = useRef(false);

  if (serviceFee == null) {
    if (!feeMissingLogged.current) {
      feeMissingLogged.current = true;
      globalThis?.Sentry?.captureException(
        new Error('service fee missing'),
        {
          extra: { enquiryId, vrm },
          level: 'info',
          tags: {
            domain: 'service_fee',
          },
        },

      );
    }
    return null;
  }

  if (!feeMismatchLogged.current && serviceFee.price !== soldForFigure) {
    feeMismatchLogged.current = true;
    globalThis?.Sentry?.captureException(
      new Error('service fee price mismatch'),
      {
        extra: {
          enquiryId,
          feeAmountGBP: serviceFee.feeAmountGBP,
          feeSourcePrice: serviceFee.price,
          soldForFigure,
          vrm,
        },
        level: 'info',
        tags: {
          domain: 'service_fee',
        },
      },

    );
  }

  return { feeAmountGBP: serviceFee.feeAmountGBP };
};
